//@flow
import React, { FC } from 'react';
import Loading from './Loading';
import { useQuery } from '../hooks/useQuery';
type Props = {
  query: string,
  variables: { [key: string]: any }
};

export const Query: FC<Props> = props => {
  const { query, variables } = props;

  const { data, loading, errors, refetch } = useQuery(query, { variables });

  if (loading && props.loading !== false) {
    return <Loading />;
  }

  if (errors) {
    return <span>Der er sket en fejl</span>;
  }

  return props.children({ data, loading, refetch });
};
